<a
  class="nav-link dropdown-toggle"
  role="button"
  data-bs-toggle="dropdown"
  data-bs-display="dynamic"
  aria-expanded="false"
  >
  Manage
</a>
<div class="dropdown-menu dropdown-manage">
  @if (columnChecks.marketInfoColumns | checkSomePermissions) {
    <h6 class="p-2">Market Info</h6>
    <div class="row">
      @if (columnChecks.firstMarketColumn | checkSomePermissions) {
          <div class="col-12 col-sm-6">
            @if (manageTabPermissions.viewDocumentTypesPermission | checkPermissions) {
            <a
              class="dropdown-item"
              routerLink="/document-types"
              >Document Types</a
              >
            }
          </div>
          <div class="col-12 col-sm-6">
            @if (manageTabPermissions.viewReclaimStartDatesPermission | checkPermissions) {
              <a
                class="dropdown-item"
                routerLink="/reclaim-start-dates"
                >Reclaim Start Dates</a
                >
              }
          </div>
          <div class="col-12 col-sm-6">
            @if (manageTabPermissions.viewMarketInfoPermission | checkPermissions) {
            <a
              class="dropdown-item"
              routerLink="/internal-bo-types"
              >BO Types</a
              >
            }
          </div>
          <div class="col-12 col-sm-6">
            @if (manageTabPermissions.viewStatueLimitPermission | checkPermissions) {
              <a
                class="dropdown-item"
                routerLink="/statute-of-limitations"
                >Statute of Limitations</a
                >
              }
          </div>
    }
            @if (columnChecks.secondMarketColumn | checkSomePermissions) {
              <div class="col-12 col-sm-6">
                @if (manageTabPermissions.viewDocumentValidityPermission | checkPermissions) {
                  <a
                    class="dropdown-item"
                    routerLink="/document-validity"
                    >Document Validity</a
                    >
                  }
                </div>
                <div class="col-12 col-sm-6">
                  @if (manageTabPermissions.viewInternalConfigPermission | checkPermissions) {
                    <a
                      class="dropdown-item"
                      routerLink="/internal-config"
                      >Treaty Rates</a
                      >
                    }
                  </div>
                <div class="col-12 col-sm-6">
                  @if (manageTabPermissions.viewExternalConfigPermission | checkPermissions) {
                    <a
                      class="dropdown-item"
                      routerLink="/external-config"
                      >External BO Types</a
                      >
                    }
                  </div>
                  <div class="col-12 col-sm-6">
                    @if (manageTabPermissions.viewRetroactiveTypesPermission | checkPermissions) {
                      <a
                        class="dropdown-item"
                        routerLink="/document-retrospectives"
                        >Document Retro</a
                        >
                      }
                    </div>
                    <div class="col-12 col-sm-6">
                      @if (manageTabPermissions.viewStatutoryRatesPermission | checkPermissions) {
                        <a
                          class="dropdown-item"
                          routerLink="/statutory-rates"
                          >Statutory Rates</a
                          >
                        }
                      </div>
                      <div class="col-12 col-sm-6">
                        @if (manageTabPermissions.viewRequiredDOcuments | checkPermissions) {
                          <a
                            class="dropdown-item"
                            routerLink="/required-documents"
                            >Required Documents</a
                            >
                          }
                        </div>
                      }
                    </div>
                  }

                  <h6 class="p-2 mt-45">Organization Components</h6>
                  <div class="row">
                    @if (manageTabPermissions.viewCompaniesPermission | checkPermissions) {
                      <div
                        class="col-12 col-sm-6"
                        >
                        <a class="dropdown-item" routerLink="/companies">Companies</a>
                      </div>
                    }
                    <!-- <div class="col-12 col-sm-6">
                    <a class="dropdown-item">Data Scopes</a>
                  </div> -->
                  @if (manageTabPermissions.viewUsersPermission | checkPermissions) {
                    <div
                      class="col-12 col-sm-6"
                      >
                      <a class="dropdown-item" routerLink="/users">Users</a>
                    </div>
                  }
                  <!-- <div class="col-12 col-sm-6">
                  <a class="dropdown-item">User Groups</a>
                </div> -->
                @if (manageTabPermissions.viewRolesPermission | checkPermissions) {
                  <div
                    class="col-12 col-sm-6"
                    >
                    <a class="dropdown-item" routerLink="/roles">User Roles</a>
                  </div>
                }
                @if (manageTabPermissions.viewEmailsPermission | checkPermissions) {
                  <div
                    class="col-12 col-sm-6"
                    >
                    <a class="dropdown-item" routerLink="/automated-emails">Automated Emails</a>
                  </div>
                }
                <!-- <div class="col-12 col-sm-6">
                <a class="dropdown-item">Templates</a>
              </div> -->
            </div>

            <h6 class="p-2 mt-45">Tax Certification Components</h6>
            <div class="row">
              @if (manageTabPermissions.viewAuthSignPermission | checkPermissions) {
                <div
                  class="col-12 col-sm-6"
                  >
                  <a class="dropdown-item" routerLink="/authorized-signatories">Authorized Signatories</a>
                </div>
              }
              @if (manageTabPermissions.viewAccountsPermission | checkPermissions) {
                <div
                  class="col-12 col-sm-6"
                  >
                  <a class="dropdown-item" routerLink="/accounts">Accounts</a>
                </div>
              }
              @if (manageTabPermissions.viewCAEventDataPermission | checkPermissions) {
                <div
                  class="col-12 col-sm-6"
                  >
                  <a class="dropdown-item" routerLink="/corporate-actions">Corporate Actions</a>
                </div>
              }
              @if (manageTabPermissions.viewProjectsPermission | checkPermissions) {
                <div
                  class="col-12 col-sm-6"
                  >
                  <a class="dropdown-item" routerLink="/projects">Projects</a>
                </div>
              }
              @if (manageTabPermissions.viewSecDataPermission | checkPermissions) {
                <div
                  class="col-12 col-sm-6"
                  >
                  <a class="dropdown-item" routerLink="securities-data">Securities</a>
                </div>
              }
            </div>
          </div>
